// @helpers
const { APIPost } = require('utilities/APIRequestHelper');

// @ constants
const actionTypes = require('constants/actionTypes');

//@actions
const signaturePatternActions = require('actions/signaturePattern');

// @constants
const {
    THIRD_STEP,
} = require('constants/index');

const validateStep = (step) => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_VALIDATE_STEP,
    payload: {
        step
    }
});

const setVisibleStep = (step) => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_SET_VISIBLE_STEP,
    payload: {
        step
    }
});

const resetState = () => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_RESET
});

const setWillCancel = (willCancel) => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_WILL_CANCEL,
    payload: {
        willCancel
    }
});

const addFile = (fileState) => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_ADD_FILE,
    payload: fileState
});

const removeFile = (index) => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_REMOVE_FILE,
    payload: {
        index
    }
});

const setDescription = (index, description) => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_SET_DESCRIPTION,
    payload: {
        index,
        description
    }
})

const setAccount = (fromAccount) => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_SET_ACCOUNT,
    payload: {
        fromAccount
    }
});

const fileUploadSuccess = (index) => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_FILE_UPLOAD_SUCCESS,
    payload: {
        index
    }
});

const fileUploadErrror = (index, error) => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_FILE_UPLOAD_ERROR,
    payload: {
        index,
        error
    }
});

const directDebitUploadProgress = () => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_UPLOAD_REQUEST
});

const directDebitUploadSuccess = () => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_UPLOAD_SUCCESS
});

const directDebitUploadError = (error) => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_UPLOAD_ERROR,
    payload: {
        error
    }
});

const directDebitUploadPartialSuccess = () => ({
    type: actionTypes.ACCOUNT_DIRECT_DEBIT_UPLOAD_PARTIAL_SUCCESS
});

const uploadFiles = () => (dispatch, getState) => {
    const immAccounts = getState().accounts;
    const accountDirectDebits = getState().accountDirectDebits;
    const immProfileFields = getState().profile;
    const immAccount = immAccounts.getIn(['byId', accountDirectDebits.get('fromAccount')]);
    const filesAttached = accountDirectDebits.getIn(['steps', THIRD_STEP, 'filesAttached']);

    const callback = (dispatch, getState, dataToken) => {
        dispatch(directDebitUploadProgress());
        const ibanComplex = immAccount.get('ibanComplex');
        const checksum = ibanComplex.get('digitodecontrol');
        const code = ibanComplex.get('codbban');
        const country = ibanComplex.get('pais');
        const clientFirstName = immProfileFields.get('nombreCliente', '').trim();
        const clientSurName = immProfileFields.getIn(['apellidoUno','apellido'],'').trim();
        let clientLastName;
        if(clientSurName) {
            clientLastName = clientSurName + " " + immProfileFields.getIn(['apellidoDos','apellido'],'').trim();
        }else {
            clientLastName = immProfileFields.getIn(['apellidoDos','apellido'],'').trim();
        }
        let allPassed = true;
        let allFailed = true;
        const allFilesPromises = filesAttached.map((file, index) => {
            const fileName = file.get('name');
            const fileComments = file.get('description');
            const fileData = file.getIn(['data','base64']);
            const fileBase64 = fileData && fileData.split('base64,')[1];
            const requestData = {
                query: {
                    client: {
                        name: clientFirstName,
                        surname: clientLastName,
                    },
                    accountNumber: {
                        checksum,
                        code,
                        country
                    },
                    fileName,
                    fileComments,
                    file: fileBase64,
                    dataToken
                }
            }
            return APIPost({
                dispatch,
                endpoint: 'accountDirectDebitUpload',
                params: requestData
            })
            .catch((error) => {
                dispatch(fileUploadErrror(index, error));
            });
        });

        return Promise.all(allFilesPromises)
            .then((responses) => {
                responses.forEach((response, index) => {
                    if(response) {
                        allFailed = false;
                        dispatch(fileUploadSuccess(index));
                    }else {
                        allPassed = false;
                    }
                });
                if(allPassed) {
                    dispatch(directDebitUploadSuccess());
                } else if(!allFailed) {
                    dispatch(directDebitUploadPartialSuccess());
                } else {
                    throw new Error();
                }
            })
            .catch((error) => {
                dispatch(directDebitUploadError(error));
            });
    }

    return Promise.resolve().then(() => {
        signaturePatternActions.validateAndExecute(dispatch, getState, callback);
    });
}

module.exports = {
    addFile,
    removeFile,
    resetState,
    setAccount,
    setDescription,
    setVisibleStep,
    setWillCancel,
    uploadFiles,
    validateStep
};
